import axios from "axios"
import { embarkationListSchema } from "../schemas/embarkation"

const Endpoint = "/api/embarkations"

export const getEmbarkationList = async () => {
    const res = await axios.get(Endpoint)
    return await embarkationListSchema.validate(res.data.data)
}
